module.exports = __webpack_public_path__ + "static/media/brand-kit-mobile.51ec2d39.png";